import styled from '@emotion/styled';
import { FC, useRef } from 'react';

import Pulse from 'app/components/v2/animations/Pulse';
import Box from 'app/components/v2/components/Box';
import Icon, { IconProps as IProps } from 'app/components/v2/components/Icon';
import Jewel from 'app/components/v2/components/Jewel';
import Heading5 from 'app/components/v2/components/Text/Heading5';
import Tooltip from 'app/components/v2/components/Tooltip';
import { useGeneralState } from 'app/state/GeneralContext/hooks';

// Local Typings
interface Props {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  IconProps: IProps;
  hasNotifications: boolean;
  isActive: boolean;
  label: string;
}

// Local Variables
const StyledPulse = styled(Pulse)({
  position: 'absolute',
  transform: 'translate(-60%, -10%)',
});

// Component Definition
const NavigationLinkUI: FC<Props> = ({
  // eslint-disable-next-line @typescript-eslint/naming-convention
  IconProps,
  hasNotifications,
  isActive,
  label,
}) => {
  const { isSideNavOpen } = useGeneralState();
  const spanRef = useRef<HTMLSpanElement>(null);

  return (
    <Box
      alignItems="center"
      display="flex"
      fullWidth
      paddingY={2}
      transition="border 200ms"
    >
      {isSideNavOpen
        ? (
          <Box
            as="span"
            display="flex"
            marginRight={4}
          >
            <Icon
              {...IconProps}
            />

            {hasNotifications && (
              <StyledPulse>
                <Jewel />
              </StyledPulse>
            )}
          </Box>
        )
        : (
          <Tooltip
            childRef={spanRef}
            tooltipLabel={label}
            tooltipPlacement="right"
          >
            <Box
              as="span"
              display="flex"
              marginRight={4}
              ref={spanRef}
            >
              <Icon
                {...IconProps}
                color={isActive ? 'info' : IconProps.color}
                size="xs"
              />

              {hasNotifications && (
                <StyledPulse>
                  <Jewel />
                </StyledPulse>
              )}
            </Box>
          </Tooltip>
        )}

      <Heading5
        fontWeight="bold"
        lineHeight="1.0"
        marginRight={4}
        noWrap
        opacity={isSideNavOpen ? 1 : 0}
        testId={`nav-link-${label.toLowerCase()}`}
        textColor={isActive ? 'active' : 'light'}
        transition="300ms opacity"
      >
        {label}
      </Heading5>
    </Box>
  );
};

export default NavigationLinkUI;
